import axios from "axios";
import { OrganizationURL } from "../../../config/UrlEndPoint";

export const URL = `${OrganizationURL}plan_payment`;

// Get Billing All For use Combobox data
export function getBillingAll() {
  return axios.get(URL);
}

export function getBillingInvoice() {
  return axios.get(`${URL}/get_invoice`);
}

export const getPaymentType = () => {
  return axios.get(`${URL}/get_payment_type_list`);
};

export const createPayment = (payload) => {
  return axios.post(`${URL}/create_payment`, payload);
};

export const getInvoiceList = (queryParams) => {
  return axios.post(`${URL}/get_invoice_list`, queryParams);
};
